var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
var _b, _c, _d, _e;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { defaultTheme } from "react-admin";
import { adminTheme } from "@sequentech/ui-essentials";
export var mixedAdminTheme = __assign(__assign({}, defaultTheme), adminTheme);
var AdminMuiButton = {
    styleOverrides: (_c = (_b = adminTheme.components) === null || _b === void 0 ? void 0 : _b.MuiButton) === null || _c === void 0 ? void 0 : _c.styleOverrides,
    variants: __spreadArray([], (((_e = (_d = adminTheme.components) === null || _d === void 0 ? void 0 : _d.MuiButton) === null || _e === void 0 ? void 0 : _e.variants) || []), true),
};
export var fullAdminTheme = __assign(__assign({}, mixedAdminTheme), { sidebar: {
        width: 300,
        closedWidth: 50,
    }, components: __assign(__assign({}, mixedAdminTheme.components), { MuiButton: __assign({}, AdminMuiButton), MuiToolbar: {
            styleOverrides: {
                root: {
                    "&:last-child": {
                        borderRight: "1px solid #0F054C",
                    },
                },
            },
        }, MuiTextField: {
            styleOverrides: {
                root: {
                    //"margin": 0,
                    "width": "100%",
                    "& .MuiInputBase-input": {
                    //fontSize: "16px",
                    //padding: "4px 12px",
                    },
                },
            },
        }, MuiInputBase: {
            styleOverrides: {
                root: {
                    //marginTop: "4px",
                    //marginBottom: 0,
                    "& #tenant-oelect": {
                        fontSize: "16px",
                        padding: "4px 12px",
                    },
                },
            },
        }, RaSidebar: {
            styleOverrides: {
                root: {
                    //"boxShadow":
                    //    "0px 2px 1px -1px rgba(0, 0, 0, 0.20), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
                    "paddingRight": "4px",
                    "paddingLeft": "4px",
                    "height": "100%",
                    "& .RaMenu-open": {
                        flexGrow: 2,
                        paddingBotton: 0,
                        marginBottom: "4px",
                    },
                    "& .RaMenu-closed": {
                        flexGrow: 2,
                        paddingBotton: 0,
                        marginBottom: "4px",
                    },
                    "& .RaSidebar-fixed": {
                        dioplay: "flex",
                        flexDirection: "column",
                        height: "100%",
                    },
                },
            },
        }, RaAppBar: {
            styleOverrides: {
                root: {
                    "& .RaAppBar-menuButton": {
                        display: "none",
                    },
                },
            },
        }, MuiDrawer: {
            styleOverrides: {
                root: (_a = {
                        "& .MuiDrawer-paper": {
                            width: "50%",
                        }
                    },
                    // doesn't work but it's a good try..
                    _a[mixedAdminTheme.breakpoints.down("xs") + "& .MuiDrawer-paper"] = {
                        width: "50%",
                    },
                    _a),
            },
        }, RaLayout: {
            styleOverrides: {
                root: {
                    "& .RaLayout-content > .list-page > .RaList-main": {
                        overflow: "auto",
                        marginRight: "4px",
                    },
                    "& .RaLayout-appFrame": {
                        marginTop: 0,
                        position: "absolute",
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                        overflow: "auto",
                        backgroundColor: adminTheme.palette.lightBackground,
                    },
                },
            },
        }, MuiSwitch: {
            styleOverrides: {
                thumb: {},
                track: {},
                switchBase: {
                    "& + .MuiSwitch-track": {
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                    },
                    ".MuiSwitch-thumb": {
                        color: "#fff",
                    },
                    "&.Mui-checked": {
                        "& + .MuiSwitch-track": {
                            backgroundColor: "#0F054C",
                            opacity: 0.5,
                        },
                        ".MuiSwitch-thumb": {
                            color: "#0F054C",
                        },
                    },
                    "&.Mui-disabled + .MuiSwitch-track": {
                        opacity: 0.5,
                    },
                },
            },
        }, MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: "#43E3A1",
                },
            },
        }, MuiTab: {
            styleOverrides: {
                root: {
                    "textTransform": "uppercase",
                    "fontWeight": "500",
                    "fontSize": "14px",
                    "fontFamily": "Roboto",
                    "lineHeight": "24px",
                    "color": "#000",
                    "opacity": 0.4,
                    "letter": "0.4",
                    "cursor": "pointer",
                    "&:hover": {
                        opacity: 0.6,
                    },
                    "&.Mui-selected": {
                        color: "#0F054C",
                        opacity: 1,
                    },
                },
            },
        }, MuiAccordion: {
            styleOverrides: {
                root: {
                    "&.MuiPaper-root": {
                        position: "relative !important",
                    },
                },
            },
        } }) });
